import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Landmark } from "lucide-react";
import { GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export const SubeListesiAyar = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const yukle = () => api.get("/banka-subeleri/durum").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { yukle(); }, []);
  const gonder = async (e) => {
    const dosya = e.target.files?.[0];
    e.target.value = "";
    if (!dosya) return;
    const fd = new FormData();
    fd.append("dosya", dosya);
    setBusy(true);
    try { const r = await api.post("/banka-subeleri/yukle", fd, { headers: { "Content-Type": "multipart/form-data" } }); setD(r.data); toast.success(`${r.data.banka_sayisi} bankanın ${r.data.sube_sayisi} şubesi yüklendi`); } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <div className="glass rounded-2xl p-5 space-y-4 max-w-3xl" data-testid="sube-listesi-ayar">
      <div className="flex items-center gap-2 font-head font-semibold"><Landmark className="w-5 h-5 text-[var(--g1)]" />Banka şube listesi</div>
      {d && <div className="text-sm" data-testid="sube-listesi-durum">
        {d.kaynak === "tcmb" ? <>Merkez Bankası listesi yüklü: <b>{d.banka_sayisi}</b> banka, <b>{d.sube_sayisi}</b> şube · {d.dosya} · {(d.tarih || "").slice(0, 10).split("-").reverse().join(".")} ({d.yukleyen})</>
          : <>Dahili liste kullanılıyor: <b>{d.banka_sayisi}</b> banka, <b>{d.sube_sayisi}</b> şube. Tüm bankalar için Merkez Bankası dosyasını yükleyin.</>}
      </div>}
      <ol className="text-xs text-muted-foreground list-decimal pl-5 space-y-1">
        <li>Merkez Bankası'nın "Banka ve Şube Bilgileri" sayfasından <b>bankaSubeTumListe.xml</b> dosyasını indirin (tcmb.gov.tr → Ödeme Sistemleri → EFT → Banka Şube Listesi).</li>
        <li>Aşağıdaki düğmeyle dosyayı seçin; eski liste silinip yenisi tek seferde yüklenir.</li>
        <li>Kayıtlarda elle yazılıp öğrenilen şubeler korunur.</li>
      </ol>
      <input ref={ref} type="file" accept=".xml,text/xml" className="hidden" onChange={gonder} data-testid="sube-listesi-dosya" />
      <GradButton data-testid="sube-listesi-yukle" disabled={busy} onClick={() => ref.current?.click()}><Upload className="w-4 h-4" />{busy ? "Yükleniyor…" : "Şube listesini yükle (XML)"}</GradButton>
    </div>
  );
};
